import { mdiWallet } from '@mdi/js';
import { Button } from '@mollybet/ui';
import { Currency } from 'common/classes/currency';
import { BaseTable, ColumnProp } from 'common/components/table/base';
import { TableTitle } from 'common/components/tables';
import { Wallet } from 'common/state/banking/actions';
import React, { useMemo } from 'react';
import { ModalModes } from '../customer';

export interface WalletsTable {
  setSelectedWallet: (wallet: Wallet) => void;
  setModalMode: (mode: ModalModes) => void;
  wallets: Wallet[];
  isLoading?: boolean;
}

export const WalletsTable = ({
  setSelectedWallet,
  setModalMode,
  wallets,
  isLoading,
}: WalletsTable) => {
  const columns = useMemo(
    (): ColumnProp<Wallet>[] => [
      { key: 'title', title: 'Name' },
      { key: 'currency', title: 'Currency' },
      {
        key: 'balance',
        title: 'Wallet Balance',
        valueFormatter: (row) =>
          new Currency(row.balance, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.balance, row.currency).toString({ symbol: false }),
      },
      {
        key: 'deposit',
        title: 'Deposits / Withdrawals',
        width: 110,
        valueFormatter: (row) =>
          new Currency(row.deposit, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.deposit, row.currency).toString({ symbol: false }),
      },
      {
        key: 'credit',
        title: 'Credit',
        valueFormatter: (row) =>
          new Currency(row.credit, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.credit, row.currency).toString({ symbol: false }),
      },
      {
        key: 'settlement_threshold',
        title: 'Profit / Losses - Settlement Threshold',
        width: 190,
        valueFormatter: (row) =>
          new Currency(row.settlement_threshold, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.settlement_threshold, row.currency).toString({
            symbol: false,
          }),
      },
      {
        key: 'min_balance',
        title: 'Min Balance',
        valueFormatter: (row) =>
          new Currency(row.min_balance, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.min_balance, row.currency).toString({
            symbol: false,
          }),
      },
      {
        key: 'actions',
        title: 'Actions',
        valueFormatter: (row) => (
          <>
            <Button
              onClick={() => {
                setSelectedWallet(row);
                setModalMode('credit');
              }}
            >
              Set Credit Limit
            </Button>
            <Button
              onClick={() => {
                setSelectedWallet(row);
                setModalMode('threshold');
              }}
            >
              Set Threshold
            </Button>
            <Button
              onClick={() => {
                setSelectedWallet(row);
                setModalMode('minBalance');
              }}
            >
              Set Min Blanace
            </Button>
          </>
        ),
      },
    ],
    [setModalMode, setSelectedWallet]
  );

  return (
    <>
      <TableTitle icon={mdiWallet} title="Wallets" />
      <BaseTable
        columns={columns}
        rows={wallets || []}
        csvName="Wallets"
        isLoading={isLoading}
        paginate={false}
      />
    </>
  );
};
